'use client';
import {
  BenzingaLogo,
  BenzingaEsLogo,
  BenzingaFrLogo,
  BenzingaItLogo,
  BenzingaCryptoLogo,
  BenzingaIndiaLogo,
  BenzingaKoreaLogo,
  BenzingaJapanLogo,
  LogoVariant,
} from '@benzinga/logos-ui';
import { appEnvironment, appName } from '@benzinga/utils';
import React from 'react';
import styles from './NavigationLogo.module.scss';
import classNames from 'classnames';

export interface NavigationLogoProps {
  logoVariant?: LogoVariant;
  deviceType?: 'mobile' | 'desktop';
}

const LogosVariants = {
  france: {
    desktop: {
      Component: BenzingaFrLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaFrLogo,
      props: {
        variant: 'light',
      },
    },
  },
  india: {
    desktop: {
      Component: BenzingaIndiaLogo,
      label: 'Click to go to India home',
      props: {
        variant: 'dark',
      },
    },
    mobile: {
      Component: BenzingaIndiaLogo,
      label: 'Click to go to India home',
      props: {
        variant: 'light',
      },
    },
  },
  italy: {
    desktop: {
      Component: BenzingaItLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaItLogo,
      props: {
        variant: 'light',
      },
    },
  },
  japan: {
    desktop: {
      Component: BenzingaJapanLogo,
      props: {},
    },
  },
  korea: {
    desktop: {
      Component: BenzingaKoreaLogo,
      props: {},
    },
  },
  spain: {
    desktop: {
      Component: BenzingaEsLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaEsLogo,
      props: {
        variant: 'light',
      },
    },
  },
};

export const NavigationLogo: React.FC<NavigationLogoProps> = ({ deviceType = 'desktop', logoVariant = '' }) => {
  const isMoneyApp = appEnvironment().isApp(appName.money);
  const isIndiaApp = appEnvironment().isApp(appName.india);

  const LogoVariantData = React.useMemo(
    () => LogosVariants[logoVariant]?.[deviceType] ?? LogosVariants[logoVariant]?.['desktop'] ?? null,
    [logoVariant, deviceType],
  );

  return (
    <div className={classNames(styles.logoWrapper, 'logo-wrapper mobile-logo-wrapper', { [styles.india]: isIndiaApp })}>
      <h1 className="sr-only">Benzinga</h1>
      {deviceType === 'mobile' ? (
        LogoVariantData ? (
          <a aria-label={LogoVariantData.label ?? 'Click to go home'} href="/">
            <LogoVariantData.Component {...LogoVariantData.props} />
          </a>
        ) : (
          <a aria-label="Click to go home" href="/">
            <BenzingaLogo deviceType={deviceType} variant="light" />
          </a>
        )
      ) : logoVariant === 'crypto' && appEnvironment().isApp(appName.bz) ? (
        <a aria-label="Click to go to the Crypto home page" className="benzinga-crypto-logo-wrapper" href="/crypto">
          <BenzingaCryptoLogo />
        </a>
      ) : (
        <>
          {LogoVariantData ? (
            <a aria-label={LogoVariantData.label ?? 'Click to go home'} href="/">
              <LogoVariantData.Component {...LogoVariantData.props} />
            </a>
          ) : (
            <a aria-label="Click to go home" href="/">
              <BenzingaLogo deviceType={deviceType} variant={isMoneyApp ? 'light' : 'dark'} />
            </a>
          )}
          {isMoneyApp && (
            <a aria-label="Click to go to Benzinga Money" href="/money">
              <div className={styles.siteLabel}>
                <span>{appEnvironment().app()}</span>
              </div>
            </a>
          )}
        </>
      )}
    </div>
  );
};
